// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__kwNAl","rowsWrapper":"style_rowsWrapper__3WRIj","rowWrapper":"style_rowWrapper__1mQ2B"};